/** Specific utility to exclude the first parameter of a function */
export type ParametersExceptFirst<T extends (...args: unknown[]) => unknown> = T extends (
    // oxlint-disable-next-line no-unused-vars
    ignored: infer _,
    ...args: infer P
) => infer TReturn
    ? (...args: P) => TReturn
    : never;

/**
 * Represents the state of an asynchronous operation that may be loading, have an error, or contain a value.
 * Used for UI components that need to display loading states while data is being fetched/decrypted.
 *
 * @template T - The type of the value when available
 */
export type AsyncState<T> = { loading: boolean; error?: boolean; value?: T };
